if (!customElements.get('multi-column-slider')) {
  class MultiColumnSlider extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-multi-column-rail]');
      this.indicator = this.querySelector('[data-multi-column-indicator]');
      this.indicatorValue = this.querySelector('[data-multi-column-indicator-value]');

      if (!this.rail || !this.indicator || !this.indicatorValue) return;

      this.abortController = new AbortController();
      this.mobileViewport = window.matchMedia('(max-width: 767px)');
      this.updateFrame = null;

      this.rail.addEventListener('scroll', () => this.scheduleUpdate(), {
        passive: true,
        signal: this.abortController.signal,
      });

      this.handleViewportChange = () => this.scheduleUpdate();
      this.mobileViewport.addEventListener('change', this.handleViewportChange);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.rail);
      } else {
        window.addEventListener('resize', () => this.scheduleUpdate(), {
          signal: this.abortController.signal,
        });
      }

      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.mobileViewport?.removeEventListener('change', this.handleViewportChange);

      if (this.updateFrame !== null) cancelAnimationFrame(this.updateFrame);
    }

    scheduleUpdate() {
      if (this.updateFrame !== null) return;

      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.updateIndicator();
      });
    }

    updateIndicator() {
      const isMobileSlider = this.mobileViewport.matches && this.dataset.mobileLayout === 'slider';
      const hasOverflow = this.rail.scrollWidth > this.rail.clientWidth + 1;
      const showIndicator = isMobileSlider && hasOverflow;

      this.indicator.hidden = !showIndicator;
      if (!showIndicator) return;

      const firstItem = this.rail.firstElementChild;
      if (!firstItem) return;

      const railRect = this.rail.getBoundingClientRect();
      const firstRect = firstItem.getBoundingClientRect();
      const isRtl = getComputedStyle(this.rail).direction === 'rtl';
      const scrollableWidth = Math.max(this.rail.scrollWidth - this.rail.clientWidth, 0);
      const scrollOffset = isRtl
        ? Math.max(firstRect.right - railRect.right, 0)
        : Math.max(railRect.left - firstRect.left, 0);
      const visibleProgress = this.rail.scrollWidth > 0 ? this.rail.clientWidth / this.rail.scrollWidth : 1;
      const scrollProgress = scrollableWidth > 0 ? Math.min(scrollOffset / scrollableWidth, 1) : 1;
      const progress = Math.min(visibleProgress + scrollProgress * (1 - visibleProgress), 1);

      this.indicatorValue.style.setProperty('--horizontal-scroll-progress', progress.toFixed(4));
    }
  }

  customElements.define('multi-column-slider', MultiColumnSlider);
}
